export type Theme = typeof defaultTheme;

export const defaultTheme = {
  newColors: {
    // PRIMARY
    primary100: "#055A60",
    primaryDark: "#033D41",
    primaryDisabled: "#78ADB0",
    primary80: "#17B0AD",
    primary60: "#9DDEDD",
    primary40: "#BCE9E8",
    primary20: "#DCF3F3",
    primary10: "#EDF9F9",
    primary05: "#F9FDFD",
    // SECONDARY
    secondary100: "#EB5C37",
    secondaryDark: "#D13C15",
    secondary80: "#EF7D59",
    secondary60: "#F89B7E",
    secondary40: "#FAB9A4",
    secondary20: "#F8D8CE",
    secondary10: "#FBE8E2",
    secondary05: "#FFF6F3",
    // GRAY
    gray100: "#2F2F2F",
    grayDark: "#181818",
    gray90: "#464646",
    gray80: "#737373",
    gray60: "#999999",
    gray40: "#D1D1D1",
    gray30: "#E3E3E3",
    gray20: "#EDEDED",
    gray10: "#F3F3F3",
    gray05: "#F8F8F8",
    // STATES
    error: "#D13C15",
    errorBg: "#FBEFEC",
    warning: "#FFB81C",
    warningBg: "#FFF6E4",
    success: "#7EBD5F",
    successBg: "#F0F7EC",
    info: "#65B4E5",
    infoBg: "#EDF6FC",
    // MISC
    violet: "#7B76B6",
    black: "#000000",
    white: "#FFFFFF",
    inactive: "#9BBDBF",
    blue: "#1197DF"
  },
  colors: {
    backgroundMain: "#fff",
    gray500: "rgba(91, 101, 110, 0.1)",
    greenerWhite: "#e7f2f2",
    warmWhite: "#e0dfe0",
    lighterGray: "#F3F3F3",
    grayMedium: "#D1D1D1",
    lightGray: "rgba(5, 90, 96, 0.06)",
    gray: "#e3e4e6",
    darkGray: "#979797",
    black: "#3b352e",
    semiGray: "#3d3934",
    red: "#D13C15",
    darkRed: "#cc0000",
    green: "#118380",
    darkGreen: "#055A60",
    lighterGreen: "#37959c",
    blue: "#0b97df",
    textPrimary: "#222",
    textSemitransparent: "rgba(34,34,34,0.55)",
    white: "#fff",
    textGray: "rgba(60, 54, 47, 0.5)",
    transparent: "transparent",
    yellow: "#fbc61f",
    lightGreen: "#acba17",
    orange: "#ef731b",
    semiBlack: "#333333",
    darkBlack: "#181818",
    error: "#D13C15",
    errorBg: "#FBEFEC",
    warning: "#FFB81C",
    warningBg: "#FFF6E4",
    success: "#7EBD5F",
    successBg: "#F0F7EC",
    info: "#65B4E5",
    infoBg: "#EDF6FC"
  },
  shadows: {
    elevation1: "0px 1px 1px rgba(10, 27, 56, 0.24), 0px 0px 1px rgba(10, 27, 56, 0.32)",
    elevation2: "0px 1px 2px rgba(10, 27, 56, 0.08), 0px 2px 4px rgba(10, 27, 56, 0.12)",
    elevation3: "0px 8px 12px rgba(10, 27, 56, 0.16), 0px 0px 1px rgba(10, 27, 56, 0.32)",
    elevation4: "0px 10px 16px rgba(10, 27, 56, 0.16), 0px 0px 1px rgba(10, 27, 56, 0.32)",
    elevation5: "0px 18px 28px rgba(10, 27, 56, 0.16), 0px 0px 1px rgba(10, 27, 56, 0.32)",
    inset1: "inset 0px 1px 2px rgba(10, 27, 56, 0.08), inset 0px 2px 4px rgba(10, 27, 56, 0.12)"
  },
  opacity: {
    hover: 0.7,
    disabled: 0.7,
    focus: 0.9
  },
  opacityHover: 0.6,
  opacityDisabled: 0.6,
  media: {
    belowXl: "@media (max-width: 1199px)",
    belowLg: "@media (max-width: 991px)",
    belowMd: "@media (max-width: 767px)",
    belowSm: "@media (max-width: 575px)"
  }
};

export type TDefaultThemeColor = keyof typeof defaultTheme.colors;
export type TDefaultThemeNewColor = keyof typeof defaultTheme.newColors;
